module.exports = __webpack_public_path__ + "img/g.6484678e.jpg";